import React from 'react';
import moment from 'moment';
import { IMSubscriptionPlan } from '@/types';
import { priceView } from '@/utils/utils';

interface PlanSummaryProps {
  plan: IMSubscriptionPlan;
  trialEndDate: number | null;
  isMobile?: boolean;
}

const PlanSummary: React.FC<PlanSummaryProps> = ({
  plan,
  trialEndDate,
  isMobile = false
}) => {
  const desktopClass = "lg:mb-8 last:mb-0";
  const textSizeClass = isMobile ? "text-[13px]/[1.2]" : "text-[13px]/[1.2] lg:text-base";
  const trialPeriodDays = Math.ceil(moment(trialEndDate).diff(moment(), 'hours') / 24);

  return (
    <>
      <div className={`flex justify-between md:gap-2 lg:gap-3 ${textSizeClass} font-medium leading-none ${desktopClass}`}>
        <span>{plan.name}</span>
        <span>
          <span>{priceView(plan.flatFee, 'USD')}</span>
          <span>/{plan.period === 'month' ? 'mo' : 'yr'}</span>
        </span>
      </div>

      <div className={`${textSizeClass} font-medium mt-auto ${isMobile ? '' : 'lg:mb-20'}`}>
        {trialPeriodDays > 0 ? (
          <>
            <div className={`flex justify-between md:gap-2 lg:gap-3 ${textSizeClass} font-medium leading-none mt-5 lg:mt-0 ${desktopClass}`}>
              <span>Due {moment().add(trialPeriodDays, 'days').format('MMM D')}</span>
              <span className="flex flex-col text-right">
                <span>{priceView(plan.flatFee, 'USD')}</span>
                <span className="md:text-[11px] lg:text-[13px]/[1.2] mt-1.5 lg:mt-1">Taxes calculated at checkout</span>
              </span>
            </div>
            <div className={`flex justify-between md:gap-2 lg:gap-3 ${textSizeClass} font-medium leading-none mt-5 lg:mt-0 ${desktopClass}`}>
              <span>Due now</span>
              <span className="flex flex-col text-right">
                <span>{priceView(0, 'USD')}</span>
                <span className="md:text-[11px] lg:text-[13px]/[1.2] text-[#19A28B] mt-1.5 lg:mt-1">{trialPeriodDays} days free</span>
              </span>
            </div>
          </>
        ) : (
          <>
            <div className={`flex justify-between md:gap-2 lg:gap-3 ${textSizeClass} font-medium leading-none mt-5 lg:mt-0 ${desktopClass}`}>
              <span>Due now</span>
              <span className="flex flex-col text-right">
                <span>{priceView(plan.flatFee, 'USD')}</span>
                <span className="md:text-[11px] lg:text-[13px]/[1.2] mt-1.5 lg:mt-1">Taxes calculated at checkout</span>
              </span>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PlanSummary;
